<header class="main-header">
  <!-- Brand Logo (Left) - Routes to Home -->
  <div class="brand-header" (click)="navigateToHome()" style="cursor: pointer;">
    <img src="/Docsila_logo.png" alt="DocSila" class="brand-logo-header">
  </div>

  <!-- Navigation Buttons in Header -->
  <div class="header-nav-buttons">
    <!-- Stats Dashboard Button -->
    @if (iconConfig.showStatsDashboard) {
      <button class="header-nav-btn" (click)="navigateToStatsDashboard()" title="Analytics">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
      </button>
    }

    <!-- Operational Health Button -->
    @if (iconConfig.showOperationalHealth) {
      <button class="header-nav-btn" (click)="navigateToOperationsRequestAnalytics()" title="Operational Health">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
        </svg>
      </button>
    }

    <!-- Evaluation Button -->
    @if (iconConfig.showEvaluation) {
      <button class="header-nav-btn" (click)="navigateToEvaluationDashboard()" title="Evaluation">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon">
          <polyline points="9 11 12 14 22 4"></polyline>
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
        </svg>
      </button>
    }

    <!-- Admin Settings Button -->
    @if (iconConfig.showAdmin) {
      <button class="header-nav-btn admin-settings-btn" (click)="navigateToAdminSettings()" title="Admin">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="nav-icon">
          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
      </button>
    }

    <!-- Client Selector (New) -->
    @if (iconConfig.showRoleBadge && shouldShowClientFilter) {
      <div class="client-selector-container" [class.has-dropdown]="hasMultipleClients">
        <!-- Client Logo + Name Display -->
        <div class="client-display" 
             [class.clickable]="hasMultipleClients"
             (click)="toggleClientDropdown(); $event.stopPropagation()"
             [title]="currentClient ? formatClientName(currentClient.client_name) : 'No clients assigned'">
          <!-- Client Logo (Generic Icon) -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="client-icon">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          
          <!-- Client Name -->
          @if (currentClient) {
            <span class="client-name" [title]="formatClientName(currentClient.client_name)">{{ formatClientName(currentClient.client_name) }}</span>
          } @else if (isLoadingClients) {
            <span class="loading-dots" aria-hidden="true">
              <span></span><span></span><span></span>
            </span>
          } @else {
            <span class="client-name disabled">No Clients</span>
          }

          <!-- Dropdown Arrow (only if multiple clients) -->
          @if (hasMultipleClients) {
            <svg class="dropdown-arrow" [class.open]="showClientDropdown" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          }
        </div>

        <!-- Client Dropdown (Scrollable List) -->
        @if (showClientDropdown && hasMultipleClients) {
          <div class="client-dropdown" [style.max-width]="dropdownWidth" (click)="$event.stopPropagation()">
            @for (client of assignedClients; track client.client_id) {
              <div class="client-option" 
                   [title]="formatClientName(client.client_name)"
                   [class.selected]="currentClient?.client_id === client.client_id"
                   (click)="selectClient(client.client_id, $event)">
                {{ formatClientName(client.client_name) }}
              </div>
            }
          </div>
        }

        <!-- Disabled State (No Clients) -->
        @if (!hasMultipleClients && !currentClient && assignedClients.length === 0) {
          
        }
      </div>
    }

    <!-- Role Badge -->
    @if (iconConfig.showRoleBadge) {
      @if (authService.isAdmin) {
        <span class="role-badge admin-badge" [title]="authService.getUserRoleAndEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
            <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
          </svg>
          <span>{{ authService.getUsernameFromEmail() }}</span>
        </span>
      } @else {
        <span class="role-badge user-badge" [title]="authService.getUserRoleAndEmail()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span>{{ authService.getUsernameFromEmail() }}</span>
        </span>
      }
    }

    <!-- Login/Logout Button (Right) -->
    @if (iconConfig.showLoginLogout) {
      @if (authService.isAuthenticated) {
        <button class="header-nav-btn" (click)="logout()" title="Logout">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      } @else {
        <button class="header-nav-btn login-btn" (click)="initiateLogin()" title="Login">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
            <polyline points="10 17 15 12 10 7"></polyline>
            <line x1="15" y1="12" x2="3" y2="12"></line>
          </svg>
          <span>Login</span>
        </button>
      }
    } 
  </div>
</header>
